'use strict';

angular.module('app.userAndBillingOverview', [])
	.controller('userAndBillingOverviewCtrl', ['$scope', '$rootScope', '$http' , '$modal', '$state', 'adminService', 'userAndBillingOverviewService',
		function ($scope, $rootScope, $http, $modal, $state, adminService, userAndBillingOverviewService){
		    $scope.preLoaded = false;
		    $scope.currentPage = 1;
		    $scope.pageSize = 25;
		    $scope.fieldName = null;
		    $scope.order = true;
		    $scope.tempOrder = true;
		    $scope.searchString = null;
		    $scope.Header = ["",""];
		    $scope.iconName = "";
		    $scope.contactAddressTypeId = 0;
		    $scope.mailAddressTypeId = 1;
		    $scope.billAddressTypeId = 2;  
			$scope.isGettingTotalCount = true;

		    $scope.searchUserAndBilling = function(){
		        var modalInstance = $modal.open({
		            scope: $scope,
		            templateUrl: 'app/admin/partials/user_company_name_doesnot_exist.html?app_v=deployDate',
		            controller: 'BillingPopupCtrl'
		        });
		        $scope.modalInstance = modalInstance;
		    }

		    $scope.subscriptionAndDetails = function(company_id, company_name){
		        var modalInstance = $modal.open({
		            scope: $scope,
		            templateUrl: 'app/admin/userAndBilling/userAndBillingOverview/subscriptionAndBilling/subscriptionAndBilling.html?app_v=deployDate',
		            controller: 'subscriptionAndBillingCtrl'
		        });
		        $scope.modalInstance = modalInstance;
		        $scope.company_id = company_id;
		        $scope.company_name = company_name;
		    }

		    $scope.companyDetailsModalHandler = function (current_account) {
		        var companyDetailsModalInstance = $modal.open({
		            scope: $scope,
		            templateUrl: 'app/admin/userAndBilling/userAndBillingOverview/accountDetails/accountDetails.html?app_v=deployDate',
		            controller: 'accountDetailsCtrl'
		        });

		        $scope.companyDetailsModalInstance = companyDetailsModalInstance;
		        $scope.current_account = current_account;
		    }

		    $scope.advertisersManagement = function(index){
		        $state.transitionTo('home.advertisersManagement', {id: index.id}, {
		            reload: true,
		            inherit: false,
		            notify: true
		        });
		    }

		    $scope.accountProjects = function(index) {
		        $state.transitionTo('home.accountProjects', {account_id: index.id}, {
		            reload: true,
		            inherit: false,
		            notify: true
		        });
		    }

		    $scope.createNewAccountWithoutUser = function () {
		        var createAccountModalInstance = $modal.open({
		            scope: $scope,
		            templateUrl: 'app/admin/userAndBilling/userAndBillingOverview/createAccount/createAccount.html?app_v=deployDate',
		            controller: 'createAccountCtrl'
		        });

		        $scope.createAccountModalInstance = createAccountModalInstance;
		    }

		    $scope.userAndBillings = [];
		    $scope.userNoCompany = [];
		    $scope.accountType = [];
		    $scope.preLoadData = function(){
		        var params = {
		            searchString: $scope.searchString,
		            accountTypeIds: $scope.selectedAccountType ? $scope.selectedAccountType : $scope.accountType[0].id,
		            pageNo: $scope.currentPage,
		            sortByColumn: $scope.fieldName,
		            sortType: $scope.order
		        }

		        $scope.preLoaded = true;
		        $scope.sendHttpPOST(params, true);
		    }

		    $scope.sendHttpPOST = function(params, isGetTotalCount){
		        userAndBillingOverviewService.getAccounts(params, true)
		        	.then(function(response) {
		        		$scope.userAndBillings = response.data;
		        	}, function(response) {
		        		displayError(response);
		        	});

				if (isGetTotalCount) {
					$scope.isGettingTotalCount = true;
					userAndBillingOverviewService.getNumberOfAccounts(params)
		        	.then(function(response) {
			            $scope.totalRow = response.totalRow;
						$scope.isGettingTotalCount = false;
			            $scope.pagination();
		        	}, function(response) {
		        		displayError(response);
		        	})
				}
		    }

		    $scope.renderAccountType = function() {
          $scope.accountType = [
            {
              id: [1,2,3,4],
              name: "User Accounts",
              ticked: true
            },
            {
              id: [5],
              name: "Network",
              ticked: false
            },
            {
              id: [6],
              name: "Influencer",
              ticked: false
            }
					]
		    }

		    $scope.billAddressOnResponse = function(data){
		        angular.forEach(data, function(item) {
		        	userAndBillingOverviewService.getAddressByType(item.id, $scope.billAddressTypeId, false)
		        		.then(function(responseBillAddress) {
		        			item.billAddress = responseBillAddress.data;
		        		}, function(response) {
		        			displayError(response);
		        		})
		        })
		    }

		    $scope.pagination = function(){
		        $scope.pages = adminService.pagination($scope.totalRow, $scope.pageSize);
		    };

		    //Sort by Column
		    $scope.sort = function(fieldname){
		        if($scope.fieldName != fieldname){
		            $scope.fieldName = fieldname;
		            $scope.tempOrder = $scope.order;
		            $scope.order = $scope.order;
		        }
		        if($scope.fieldName == fieldname){
		            $scope.tempOrder = $scope.order;
		            $scope.order = !$scope.order;
		        }
		        if($scope.tempOrder == true){
		            $scope.iconName = "glyphicon glyphicon-chevron-down";
		        } else{
		            $scope.iconName = "glyphicon glyphicon-chevron-up";
		        }
		        if($scope.fieldName === 'name')
		        {
		            $scope.Header[0] = $scope.iconName;
		        }
		        var params = {
		            startLetter: $scope.selectedStartLetter,
		            searchString: $scope.searchString,
		            accountTypeIds: $scope.selectedAccountType,
		            pageNo: 1,
		            sortByColumn: $scope.fieldName,
		            sortType: $scope.tempOrder
		        }

		        $scope.sendHttpPOST(params);
		    }

		    //Traverse through pages
		    $scope.updatePage = function(val){
		        $scope.currentPage = val;
		        var params = {
		            searchString: $scope.searchString,
		            accountTypeIds: $scope.selectedAccountType,
		            pageNo: $scope.currentPage,
		            sortByColumn: $scope.fieldName,
		            sortType: $scope.tempOrder
		       }

		       $scope.sendHttpPOST(params);
		    }

		    if(!$scope.preLoaded){
		        $scope.renderAccountType();
          	$scope.preLoadData();
		    }

		    $scope.searchUserAndBilling = function(){
		        $scope.accountType.forEach(function(item){
		            if(item.ticked == true){
		                $scope.selectedAccountType = item.id;
		            }
		        })
		        var params = {
		            searchString: $scope.searchString,
		            accountTypeIds: $scope.selectedAccountType,
		            pageNo: 1,
		            sortByColumn: $scope.fieldName,
		            sortType: $scope.order
		        }

		        $scope.preLoaded = true;
		        $scope.sendHttpPOST(params, true);
		    }


		    $scope.userManagement = function(index){
		        var data = {index : index};
		        $state.transitionTo('home.adminUserManagement', {data: data}, {
		            reload: true,
		            inherit: false,
		            notify: true
		        });
		    }

		    $scope.accountLog = function(index){
		        var accountDataLog = {index : index};
		        $state.transitionTo('home.systemLog', {accountDataLog: accountDataLog}, {
		            reload: true,
		            inherit: false,
		            notify: true
		        });
		    };

		    $scope.deleteAccount = function(index) {
		        var deleteAccountConfirmModalInstance = $modal.open({
		            scope: $scope,
		            templateUrl: 'app/admin/userAndBilling/userAndBillingOverview/deleteAccount/deleteAccount.html?app_v=deployDate',
		            controller: 'deleteAccountCtrl',
		        });

		        $scope.index = index;
		        $scope.deleteAccountConfirmModalInstance = deleteAccountConfirmModalInstance;
		    }

		    $scope.closeModal = function(){
		        $modalInstance.close();    
		    }

		    $scope.ActiveIcon = function(packageId) {
		        return adminService.getActiveIcon(packageId != 4); 
		    };

		    $scope.$watch('accountTypes', function(newValue, oldValue){
		        if((newValue !== undefined && newValue.length != 0) 
		                                 && (oldValue !== undefined && oldValue.length != 0))
		        {
		            if(newValue[0] != null){
		                if(newValue[0].id !== oldValue[0].id) {
		                    $scope.selectedAccountType = newValue[0].id;
		                    var params = {
		                        searchString: $scope.searchString,
		                        accountTypeIds: $scope.selectedAccountType,
		                        pageNo: 1,
		                        sortByColumn: $scope.fieldName,
		                        sortType: $scope.order
		                    }

		                    $scope.currentPage = 1;
		                    $scope.sendHttpPOST(params, true);
		                }
		            }           
		        }
		    });

			function displayError(response) {
				if (response) {
					var errorModalInstance = $modal.open({
						scope: $scope,
						templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
						windowClass: 'modal-dialog-mention-error'
					});
					$scope.errorModalInstance = errorModalInstance;
					$scope.errorMessage = response.message;
				}
			}
}])